//配信者画像
export const LIVER_IMG = {
    NORMAL: "img/takata_AI_14.png",
    KILLER_MACHINE: "img/IMG_0027.JPG",
    SUPER_CHAT_LEVEL_0: "img/takata_AI_7.png",
    SUPER_CHAT_LEVEL_1: "img/takata_AI_7.png",
    SUPER_CHAT_LEVEL_2: "img/takata_AI_3.png",
    SUPER_CHAT_LEVEL_3: "img/takata_AI_6.png",
    SUPER_CHAT_LEVEL_4: "img/takata_AI_2.png",
    SUPER_CHAT_LEVEL_5: "img/takata_AI_1.png",
    SUPER_CHAT_LEVEL_6: "img/takata_AI_10.png",
    SUPER_CHAT_LEVEL_7: "img/takata_AI_11.png",
    INCORRECT_ANSWER: "img/takata_AI_4.png",
    GOODBYE: "img/takata_AI_19.png",
}

//スパチャ額に応じたメッセージ
export const LIVER_MESSAGE = {
    SUPER_CHAT_LEVEL_1: "制限時間いっぱい\nですが、見事正解です！",
    SUPER_CHAT_LEVEL_2: "少し難しかった\nですかね？\n次も頑張ってください",
    SUPER_CHAT_LEVEL_3: "はい。正解です。\n皆さんは\nわかりましたか？",
    SUPER_CHAT_LEVEL_4: "正解です！\nよくわかりましたね",
    SUPER_CHAT_LEVEL_5: "正解！\nよくわかりましたね\nコメントも\nありがとうございます！",
    SUPER_CHAT_LEVEL_6: "はやい！\nなんでこんな早くわかるの？\n5000円もありがと！",
    SUPER_CHAT_LEVEL_7: "早すぎる！\n天才ですか！？\n赤スパもありがとう\nございます！",

    INCORRECT: "残念。不正解です。",
}